import PatentTableBody from "./components/PatentTableBody/PatentTableBody";
import PatentTableHead from "./components/PatentTableHead/PatentTableHead";
import * as S from "./PatentTable.style";

const PatentTable = () => {
  return (
    <S.PatentTable>
      <PatentTableHead />
      <PatentTableBody />
    </S.PatentTable>
  );
};

export default PatentTable;
